// src/pages/Pricing.js
import React from 'react';
import styled from 'styled-components';

const PageContainer = styled.div`
  padding-top: 80px;
  min-height: 100vh;
`;

const Pricing = () => {
  return (
    <PageContainer>
      <h1>Pricing</h1>
    </PageContainer>
  );
};

export default Pricing;